module.exports = __webpack_public_path__ + "img/mista.b45e94a6.png";